import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function listGroupsByObject(params) {
  return request({
    url: ENDPOINT.LIST_PLACE_GROUPS,
    method: 'get',
    params
  })
}

export function updateGroup(data) {
  return request({
    url: ENDPOINT.PLACE_GROUP,
    method: 'patch',
    data
  })
}

export function createGroup(data) {
  return request({
    url: ENDPOINT.PLACE_GROUP,
    method: 'post',
    data
  })
}

export function deleteGroup(params) {
  return request({
    url: ENDPOINT.PLACE_GROUP,
    method: 'delete',
    params
  })
}

export function listGroupItems(params) {
  return request({
    url: ENDPOINT.PLACE_GROUP_ITEM,
    method: 'get',
    params
  })
}

export function createItem(data) {
  return request({
    url: ENDPOINT.PLACE_GROUP_ITEM,
    method: 'post',
    data
  })
}

export function updateItem(data) {
  return request({
    url: ENDPOINT.PLACE_GROUP_ITEM,
    method: 'patch',
    data
  })
}

export function deleteItem(params) {
  return request({
    url: ENDPOINT.PLACE_GROUP_ITEM,
    method: 'delete',
    params
  })
}
